export default "__VITE_ASSET__fdeG5an7__"